const API_ENDPOINT = "/api/routing";

export default {
  data: () => ({
    toolbarMenu: {},
  }),
  methods: {
    getToolbarMenu() {
      this.$axios
        .get(`${API_ENDPOINT}/toolbar-menu`)
        .then(({ data }) => {
          this.toolbarMenu = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
  },
  created() {
    this.getToolbarMenu();
  },
};
